import { IRoute } from "../../../common/helpers/routesMapper";
import withRouter from "../../utils/withRouter";
import injectIntl from "../../../common/helpers/injectIntl";
import { connect } from "react-redux";

import { seo } from "../../../common/helpers/seo";

import { post } from "../../actions/general";
import { editUser } from "../../store/user/actions";
import { IStateTree } from "../../store/interfaces";
import { IUser } from "../../store/user/models";

import lazyComponent from "./lazy";

const mapStateToProps = ({ user }: IStateTree) => ({
    user: user as IUser,
});

const mapDispatchToProps = { post, editUser };

export default {
    component: withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(lazyComponent))),
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        return seo({ title: allMessage["signup-student.title"], allMessage, lang });
    },
} satisfies IRoute;
